"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shared = _interopRequireWildcard(require("./shared"));

var _edenStyleConstants = require('../../../../eden-style-constants');

var _hex2rgba = _interopRequireDefault(require("hex2rgba"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Component = _styledComponents.default.button.withConfig({
  componentId: "sc-11cmx9o-0"
})(["", ";padding:calc(", " - 1px) calc(", " - 1px);", ";", ";&:hover{background:none;", ";}&:active{", ";}"], _shared.default, _shared.paddingBlockStartEnd, _shared.paddingInlineStartEnd, ({
  inverted
}) => inverted ? `background: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  )` : `background: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0) 75%,
    ${(0, _hex2rgba.default)(_edenStyleConstants.blue30, 0.13)}
  )`, ({
  theme,
  inverted
}) => theme.primaryColor ? `color: ${theme.primaryColor};
         border: 1px solid ${theme.primaryColor};
        ` : inverted ? `color: ${_edenStyleConstants.white};
         border: 1px solid ${_edenStyleConstants.white};
        ` : `color: ${_edenStyleConstants.blue30};
         border: 1px solid ${_edenStyleConstants.blue30};
        `, ({
  theme,
  inverted
}) => theme.primaryColor ? `color: ${theme.primaryColor}` : inverted ? `color: ${_edenStyleConstants.white}` : `color: ${_edenStyleConstants.blue30}`, ({
  inverted
}) => inverted ? `background: linear-gradient(
        150deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.3)
      )` : `background: linear-gradient(
        150deg,
        ${(0, _hex2rgba.default)(_edenStyleConstants.blue30, 0.13)},
        rgba(255, 255, 255, 0) 25%
      )`);
/**
 * On components with multiple buttons this should be the default style used. This button style indicates that an action is a viable path to choose when completing a task. This style is subservient to the Primary button style.
 */


const Secondary = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));

Secondary.defaultProps = {
  type: "button"
};
Secondary.displayName = "Secondary";
Secondary.propTypes = {
  /** The button contents */
  children: _propTypes.default.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: _propTypes.default.bool,

  /** Whether to apply smaller styles */
  small: _propTypes.default.bool,

  /** Theme style values */
  theme: _propTypes.default.shape({
    primaryColor: _propTypes.default.string
  }),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: _propTypes.default.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: _propTypes.default.bool,

  /** If the button should be disabled */
  disabled: _propTypes.default.bool,

  /** The link that the button should navigate to on click */
  href: _propTypes.default.string
};
var _default = Secondary;
exports.default = _default;